import { render, staticRenderFns } from "./LabelsDialog.vue?vue&type=template&id=6406da3c&scoped=true&"
import script from "./LabelsDialog.vue?vue&type=script&lang=js&"
export * from "./LabelsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406da3c",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
